export class SiteDefaultValues {
  defaultCountry: string;
  defaultProvince: string;
}
